import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PatternAltitude } from '../models/pattern-altitude.model';
import { PatternAltService } from '../service/pattern-alt.service';
var EditPatternAltitudeComponent = /** @class */ (function () {
    function EditPatternAltitudeComponent(_matDialogRef, _patternAltService, _snackBar, data) {
        this._matDialogRef = _matDialogRef;
        this._patternAltService = _patternAltService;
        this._snackBar = _snackBar;
        this.isNew = false;
        this.isLoading = false;
        this.patternAlt = data.patternAlt || new PatternAltitude();
        this.isNew = data.isNew || false;
        this.airportID = data.airID;
        this.originalPatternAlt = Object.assign(new PatternAltitude(), data.patternAlt);
        this.itemsToChange = new Set();
        this.selectedAircraftClass = PatternAltitude.formatAircraftClass(this.patternAlt.aircraftClass);
        this.selectedAltitude = this.patternAlt.altitude ? this.patternAlt.altitude.toFixed(0) : '';
        this.patternAltitudes = data.patternAltitudes || [];
    }
    EditPatternAltitudeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            aircraftClass: new FormControl(this.selectedAircraftClass, [Validators.required]),
            altitude: new FormControl(this.selectedAltitude, [Validators.required, Validators.maxLength(6),
                Validators.pattern('\\d+')])
        });
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditPatternAltitudeComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        res = void 0;
                        this.patternAlt.aircraftClass = PatternAltitude.parseAircraftClass(this.formGroup.get('aircraftClass').value);
                        this.patternAlt.altitude = this.formGroup.get('altitude').value;
                        if (!this.isNew) return [3 /*break*/, 2];
                        if (this.patternAltitudes.filter(function (element) { return element.aircraftClass === _this.patternAlt.aircraftClass; }).length > 0) {
                            this._snackBar.open('There is already a pattern altitude for this aircraft class.  ' +
                                'If it is incorrect, please go back end edit it.', 'Pattern Altitude', {
                                duration: 8000
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this._patternAltService.postPatternAlt(this.airportID, this.patternAlt)];
                    case 1:
                        res = _a.sent();
                        this.patternAlt = PatternAltitude.parse(res);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._patternAltService.putPatternAlt(this.airportID, this.patternAlt)];
                    case 3:
                        res = _a.sent();
                        Object.assign(this.patternAlt, PatternAltitude.parse(res));
                        this.patternAlt = PatternAltitude.parse(res);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, patternAlt: this.patternAlt });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditPatternAltitudeComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditPatternAltitudeComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.patternAlt, this.originalPatternAlt);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditPatternAltitudeComponent;
}());
export { EditPatternAltitudeComponent };
